import React, { Component } from 'react';

export default class SearchForm extends Component {

  state = {
    searchText: ''
  }

  onSearchChange = e => {
    this.setState({ searchText: e.target.value });
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.onSearch(this.query.value); // see L26 below
    e.currentTarget.reset();
  }

  render() {
    return (
      <form className="search-form" onSubmit={this.handleSubmit} >
        <label className="is-hidden" htmlFor="search">Search</label>
        <input type="search"
          onChange={this.onSearchChange}
          name="search"
          ref={(input) => this.query = input} // puts a reference to the input on the SearchForm class. Now the callback is executed immediately after the component is mounted to the DOM. When the input is rendered on the page, it returns a reference to this input which you can access with this.query.
          placeholder="Search..." />
        <button type="submit" id="submit" className="search-button"><i className="material-icons icn-search">search</i></button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/SearchForm.js